import Image from 'next/image';
import {defaultThemeImagePaths} from '@helpers/config-master.mjs';
import HorizontalSlider from '@components/widgets/HorizontalSlider/HorizontalSlider';
import {useCallback, useState} from 'react';
import {ModalGalleryV3_YARLB} from '@components/product/desktop/ModalGalleryYetAnotherReactLightBox';
import {DesktopPreOrderOrSaleProductImageOverlay} from '@components/product/global/ProductImageOverlays';

export const DesktopClickableGallery = ({product, variants}) => {
  // console.log('[DesktopClickableGallery] product:', product);
  // console.log('[DesktopClickableGallery] variants:', variants);
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const desktopProductImageSaleOverlay = defaultThemeImagePaths?.desktopProductImageSaleOverlay;
  const sku = product?.sku;

  let allImages = product?.images ?? variants?.[0]?.images;
  allImages = allImages?.map((img) => {
    let imgUrl = img?.url;
    imgUrl = imgUrl?.replace('https://www.skaraudio.com/', '/');
    img.url = imgUrl;
    return img;
  });
  // console.log('[DesktopClickableGallery] allImages:', allImages);

  const firstImageSrc = allImages?.[0]?.url?.split('?')[0] || allImages?.url?.[0];
  const otherImages = allImages?.slice(1);

  const isInStock = product?.isInStock || product?.currentlyInStock;
  const preOrderInfo = product?.pre_order_info || product?.preOrderInfo;
  const prodName = product?.name || product?.productTitle || product?.siteName;

  const openLightbox = useCallback((index = 0) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  }, []);

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  if (!allImages?.length) return null;

  return (
    <div className="flex flex-col gap-4 md:h-auto place-content-start outline-none" tabIndex="-1">
      {firstImageSrc && (
        <div className="relative">
          <Image
            src={firstImageSrc}
            onClick={() => openLightbox(0)}
            alt={`Featured Product Photo for ${prodName}`}
            width={750}
            height={750}
            loading="eager"
            sizes="(min-width: 1300px) 1240px, 60vw"
            className="w-[100vw] md:w-full h-full md:h-auto flex-shrink-0 md:flex-shrink-none snap-start md:col-span-2 lg:border border-gray-200 rounded-lg cursor-pointer"
          />

          <DesktopPreOrderOrSaleProductImageOverlay
            product={product}
            isInStock={isInStock}
            preOrderInfo={preOrderInfo}
            desktopProductImageSaleOverlay={desktopProductImageSaleOverlay}
          />
        </div>
      )}

      <HorizontalSlider>
        {otherImages?.map((img, index) => {
          let imgUrl = img?.url;
          imgUrl = imgUrl?.replace('https://www.skaraudio.com/', '/');

          const srcImage = imgUrl?.split('?')[0];
          // console.log('[DesktopClickableGallery] imgUrl:', imgUrl);
          // console.log('[DesktopClickableGallery] srcImage:', srcImage);
          return (
            imgUrl && (
              <div
                key={`image${index}`}
                className="w-[175.75px] h-[175.75px] object-cover object-center transition-all snap-start border border-gray-200 flex-shrink-0 rounded-lg cursor-pointer overflow-hidden">
                <Image
                  src={srcImage}
                  onClick={(e) => {
                    e.preventDefault();
                    openLightbox(index + 1);
                  }}
                  width={175}
                  height={175}
                  sizes="175px"
                  alt={`Featured Product Photo ${index + 1} for ${prodName}`}
                  className="transition-all duration-300 hover:scale-105 object-cover h-full"
                />
              </div>
            )
          );
        })}
      </HorizontalSlider>

      <ModalGalleryV3_YARLB
        sku={sku}
        images={allImages}
        viewerIsOpen={viewerIsOpen}
        closeLightbox={closeLightbox}
        photoIndex={currentImage}
        setPhotoIndex={setCurrentImage}
      />
    </div>
  );
};
